import TagSituacao from "./TagSituacao";
import { ClienteSituacao } from "core/features/cliente/typings";

interface FiltroTipoStatusProps {
  setSelectedTipoStatus: (id?: ClienteSituacao) => any;
  selectedTipoStatus?: ClienteSituacao;
}
function FiltroTagStatus({
  selectedTipoStatus,
  setSelectedTipoStatus,
}: FiltroTipoStatusProps) {
  const onSelectTipoStatus = (t?: ClienteSituacao) => {
    if (selectedTipoStatus === t) {
      setSelectedTipoStatus?.(undefined);
    } else {
      setSelectedTipoStatus?.(t);
    }
  };

  return (
    <>
      <TagSituacao
        onClick={() => onSelectTipoStatus?.()}
        selected={!selectedTipoStatus}
      >
        Todos
      </TagSituacao>

      <TagSituacao
        onClick={() => onSelectTipoStatus?.(ClienteSituacao.Adimplente)}
        selected={selectedTipoStatus === ClienteSituacao.Adimplente}
      >
        Adimplentes
      </TagSituacao>

      <TagSituacao
        onClick={() => onSelectTipoStatus?.(ClienteSituacao.Inadimplente)}
        selected={selectedTipoStatus === ClienteSituacao.Inadimplente}
      >
        Inadimplentes
      </TagSituacao>

      <TagSituacao
        onClick={() => onSelectTipoStatus?.(ClienteSituacao.Novo)}
        selected={selectedTipoStatus === ClienteSituacao.Novo}
      >
        Novos clientes
      </TagSituacao>
    </>
  );
}

export default FiltroTagStatus;
